import { FC } from "react";

interface SliderArrowRightSVGProps {
    onClick?: () => void;
}

const SliderArrowRightSVG: FC<SliderArrowRightSVGProps> = (props) => {
    return (
        <div
            onClick={props.onClick}
            className="absolute right-[calc(50%-100px)] dmax2:right-[calc(50%-75px)] bottom-[-120px] dmax2:bottom-[-84px] flex justify-center items-center w-[80px] dmax2:w-[60px] h-[80px] dmax2:h-[60px] bg-[rgba(255,255,255,0.05)] hover:bg-[rgba(255,255,255,0.1)] rounded-[100px] cursor-pointer transition duration-300"
        >
            <svg width="34" height="22" viewBox="0 0 34 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 11H32.5M32.5 11L22.9561 1M32.5 11L22.9561 21" stroke="#F1F1F1" />
            </svg>
        </div>
    );
};

export default SliderArrowRightSVG;
